import { useCallback } from "react"
import { useRxCollection } from "rxdb-hooks"
import type { CollectionKey } from "src/types"
import { noticeError } from "src/utils"

type UpsertCollectionItem<T> = (item: T) => Promise<void>

export function useUpsertCollectionItem<T>(
  collectionKey: CollectionKey,
): UpsertCollectionItem<T> {
  const collection = useRxCollection<T>(collectionKey)

  return useCallback(
    async (item: T) => {
      if (collection) {
        try {
          await collection.incrementalUpsert(item)
        } catch (e) {
          noticeError(
            e,
            "RxDBUpsertCollectionItem",
            {
              item,
              collectionKey,
            },
          )
        }
      }
    },
    [
      collectionKey,
      collection,
    ],
  )
}
